 type AcquisitionLogColumn =
 'DATE' |
 'TYPE' |
 'STATION' |
 'SUBTYPE' |
 'CONNECTION_TYPE' |
 'CONNECTION_NAME' |
 'CONNECTION_ID'|
 'TAG_NAME' |
 'DATA';
const AcquisitionLogColumns = (() => {
  const DATE: AcquisitionLogColumn = 'DATE';
  const TYPE: AcquisitionLogColumn = 'TYPE';
  const SUBTYPE: AcquisitionLogColumn = 'SUBTYPE';
  const STATION: AcquisitionLogColumn = "STATION";
  const CONNECTION_TYPE: AcquisitionLogColumn = 'CONNECTION_TYPE';
  const CONNECTION_NAME: AcquisitionLogColumn = 'CONNECTION_NAME';
  const CONNECTION_ID: AcquisitionLogColumn = 'CONNECTION_ID';
  const TAG_NAME: AcquisitionLogColumn = 'TAG_NAME';
  const DATA: AcquisitionLogColumn = 'DATA';
  function values(): AcquisitionLogColumn[] {
    return [
     DATE,
     TYPE,
     SUBTYPE,
     CONNECTION_TYPE,
     CONNECTION_NAME,
     CONNECTION_ID,
     STATION,
     TAG_NAME,
     DATA
    ];
  }
  return { DATE, TYPE, SUBTYPE, STATION, CONNECTION_TYPE, CONNECTION_NAME, CONNECTION_ID, TAG_NAME, DATA, values };
})();

export { AcquisitionLogColumns };
